import i18n from 'i18next';

import st from './shared.module.sass';
import type { IStreamStatusConfigItem } from './types';
import { StreamStatusValue } from './types';

// Внутренний вид записи: label вычисляется лениво в геттерах,
// чтобы не зависеть от порядка инициализации i18n
interface IStreamStatusConfigSource {
  labelKey: string;
  colorClass: string;
  textColorClass: string;
}

const source = (
  labelKey: string,
  colorClass: string,
  textColorClass: string,
): IStreamStatusConfigSource => ({ labelKey, colorClass, textColorClass });

export const STREAM_STATUS_CONFIG_LUNA_PLATFORM: Record<number, IStreamStatusConfigSource> = {
  [StreamStatusValue.pending]: source('shared:stream statuses.pending', st.AccentBlue, st.TextAccentBlue),
  [StreamStatusValue.in_progress]: source('shared:stream statuses.in_progress', st.Positive, st.TextPositive),
  [StreamStatusValue.done]: source('shared:stream statuses.done', st.PositiveContainer, st.TextPositiveContainer),
  [StreamStatusValue.restart]: source('shared:stream statuses.restart', st.Attention, st.TextAttention),
  [StreamStatusValue.failure]: source('shared:stream statuses.failure', st.Negative, st.TextNegative),
  [StreamStatusValue.stop]: source('shared:stream statuses.stop', st.Neutral, st.TextNeutral),
  [StreamStatusValue.unknown]: source('shared:stream statuses.unknown', st.Neutral, st.TextNeutral),
  [StreamStatusValue.handler_lost]: source('shared:stream statuses.handler_lost', st.Neutral, st.TextNeutral),
  [StreamStatusValue.paused]: source('shared:stream statuses.paused', st.Neutral, st.TextNeutral),
};

export const STREAM_STATUS_CONFIG_LUNA_STREAMS: Record<string, IStreamStatusConfigSource> = {
  pending: source('shared:stream statuses.pending', st.AccentBlue, st.TextAccentBlue),
  in_progress: source('shared:stream statuses.in_progress', st.Positive, st.TextPositive),
  done: source('shared:stream statuses.done', st.PositiveContainer, st.TextPositiveContainer),
  pause: source('shared:stream statuses.paused', st.Neutral, st.TextNeutral),
  restart: source('shared:stream statuses.restart', st.Attention, st.TextAttention),
  cancel: source('shared:stream statuses.stop', st.Neutral, st.TextNeutral),
  failure: source('shared:stream statuses.failure', st.Negative, st.TextNegative),
  handler_lost: source('shared:stream statuses.handler_lost', st.Neutral, st.TextNeutral),
  not_found: source('shared:stream statuses.unknown', st.Neutral, st.TextNeutral),
  deleted: source('shared:stream statuses.unknown', st.Neutral, st.TextNeutral),
};

const UNKNOWN_SOURCE = source('shared:stream statuses.unknown', st.Neutral, st.TextNeutral);

function toConfigItem(config: IStreamStatusConfigSource): IStreamStatusConfigItem {
  return {
    label: i18n.t(config.labelKey),
    colorClass: config.colorClass,
    textColorClass: config.textColorClass,
  };
}

/** Статусы luna-platform (числовые) — компонент StreamStatus. */
export function getStreamStatusConfig(status: number): IStreamStatusConfigItem {
  return toConfigItem(STREAM_STATUS_CONFIG_LUNA_PLATFORM[status] ?? UNKNOWN_SOURCE);
}

/** Статусы luna-streams (строковые) — компонент StreamStatusLunaStreams. */
export function getLunaStreamsStatusConfig(status: string): IStreamStatusConfigItem {
  return toConfigItem(STREAM_STATUS_CONFIG_LUNA_STREAMS[status] ?? UNKNOWN_SOURCE);
}
